import React from 'react';
import { Image } from 'react-bootstrap';
import Button from '../shared/Button';
import 'bootstrap/dist/css/bootstrap.min.css';
import RespModal from '../shared/RespModal';
import '../../css/shared/SessionExpire.css';
import alert from '../../assets/images/alert.svg';
function SessionExpire(props) {
    return (
        <RespModal hasOpen={props.hasOpen}  >
            <div className="sessionExpireModalSize" >
                <Image src={alert} /><br /><br />
                <div id="sessionExpireModalContent">
                    {props.children}
                </div>
                <div class="sessionExpireModalButtonDiv">
                    <Button
                        id="sessionExpireContinueButton"
                        type="button"
                        class="btn btn-dark"
                        onClick={props.onCloseModal}
                    >Continue
        </Button>
                    <Button
                        id="sessionExpireLogoutButton"
                        type="button"
                        class="btn btn-dark"
                        onClick={props.onYesModal}
                    >Log Out
        </Button>
                </div>
            </div>
        </RespModal>
    );
}
export default SessionExpire;